import PropTypes from 'prop-types';
import React from 'react';

import { useLanguage } from '$contexts/language.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const LocaleSelector = ({ pages = [], colour = 'black' }) => {
    // hooks
    const { current } = useLanguage();

    // methods
    const getLocalePageUrl = (pages, locale) => {
        let _page;

        pages?.forEach(({ node }) => {
            if (node.locale === locale) {
                _page = node;
            }
        });

        if (!_page) {
            _page = { url: `/${locale}/` };
        }

        return _page.url;
    };

    // render
    return (
        <ul className='list-reset flex flex-col items-center type-style-5'>
            <li>
                <a
                    className={`link-reset block roundal-${colour} roundal transition-colour${current === 'de' ? ' roundal--active' : ''}`}
                    href={getLocalePageUrl(pages, 'de')}>
                    D
                </a>
            </li>

            <li>
                <a
                    className={`link-reset block roundal-${colour} roundal transition-colour${current === 'en' ? ' roundal--active' : ''}`}
                    href={getLocalePageUrl(pages, 'en')}>
                    E
                </a>
            </li>

            <li>
                <a
                    className={`link-reset block mb5 sm-mb5 md-mb7 roundal-${colour} roundal transition-colour${current === 'zh' ? ' roundal--active' : ''}`}
                    href={getLocalePageUrl(pages, 'zh')}>
                    中文
                </a>
            </li>
        </ul>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    pages: PropTypes.array,
    colour: PropTypes.string
};

LocaleSelector.propTypes = propTypes;

export { LocaleSelector };

export default LocaleSelector;
